<template>
  <div class="blog-add my-5">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="progress-up" v-if="uploadPercentage > 0 && uploadPercentage !==  100">
      <div class="parent-loading">
        <b-progress
          show-progress
          animated
          :value="uploadPercentage"
          class="mt-2 w-100"
          :variant="'info'"
        ></b-progress>
      </div>
    </div>
    <div class="container">
      <b-card>
        <div class="text-center">
          <img :src="image" :alt="form.title" class="mw-100"/>
          <upload-blog-image :isEdit="false" :width="368" :height="246" :circle="true"/>
        </div>
        <div class="row">
          <div class="col-12 my-5"></div>
          <div class="col-6 mt-3">
            <div class="group-form">
              <input
                type="text"
                v-validate="'required'"
                name="عنوان"
                :class="{active:form.title != '' }"
                v-model="form.title"
                autocomplete="off"
              />
              <span class="bar"></span>
              <label class="statr">عنوان مقاله</label>
              <span
                v-if="errors && errors.has('عنوان')"
                class="is-danger"
              >{{ errors.first('عنوان') }}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="">
              <div  v-if="filterCategories.length"  dir="rtl">
                <label class="typo__label">دسته بندی</label>
                <multiselect
                  v-model="categoryValue"
                  placeholder="دسته بندی را جستجو کنید"
                  group-label="category"
                  label="subcategory"
                  track-by="subcategory_id"
                  name="category"
                  group-values="sub"
                  :options="filterCategories"
                  selectLabel="برای انتخاب دسته بندی کلیک کنید"
                  selectedLabel="انتخاب شده"
                  deselectLabel="برای حذف دسته بندی کلیک کنید"
                >
                  <span slot="noResult">مورد مشابه یافت نشد و یا قبلا اضافه شده</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="group-form">
              <textarea
                maxlength="100"
                type="text"
                v-model="form.description"
                :class="{active:form.description != ''}"
              ></textarea>
              <span class="bar"></span>
              <label for>توضیحات مختصر</label>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-2">
              <tag :options="optionsTags"/>
            </div>
          </div>
          <div class="col-12">
            <tinymce-editor
              v-model="form.content"
              api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
              :init="configMedia"
            />
          </div>
          <div class="col-12 mt-2">
            <label class="statr">فایل پیوست</label>
            <div class="input-group my-2">
              <label class="custom-file"
                     for="pdf"
              >
                <input
                  type="file"
                  accept=".pdf"
                  id="pdf"
                  name="pdf"
                  class="custom-file-input"
                  @change="uploadFile($event)"
                />
                <span
                  class="custom-file-label"
                >{{form.pdf ? form.pdf.name : 'آپلود فایل'}}</span>
              </label>
              <div class="input-group-prepend">
                <span class="input-group-text">آپلود فایل</span>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="mt-4 d-flex">
              <m-btn
                class="ml-2"
                label="ذخیره به عنوان پیش نویس"
                @click.native="saveBlog({draft:true})"
              />
              <m-btn label="ذخیره و ارسال نهایی" @click.native="saveBlog({draft:false})"/>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import tag from "cp/min-component/tag/index.vue";
  import CategoryDropDown from "cp/min-component/category-drop-down/fullmode.vue";
  import uploadBlogImage from "cp/blog/upload-image.vue";
  import MBtn from "cp/element/button";

  export default {
    name: "add-blog",
    components: {
      tag,
      uploadBlogImage,
      CategoryDropDown,
      MBtn
    },
    data() {
      return {
        isLoading: false,
        categoryValue:null
      };
    },
    computed: {
      filterCategories() {
        return this.$store.state.categories.filterCat;
      },
      optionsTags() {
        return this.$store.state.dashboardTag.tags;
      },
      tags() {
        return this.$store.state.dashboardTag.tagCourses;
      },
      form() {
        return this.$store.state.dashboardBlog.form;
      },
      uploadPercentage() {
        return this.$store.state.dashboardBlog.uploadPercentage;
      },
      image() {
        if (this.form.imgSrc) {
          return this.form.imgSrc;
        } else {
          return "../../../static/img/blogging.png";
        }
      }
    },
    mounted() {
      this.getTag();
    },
    destroyed() {
        this.$store.dispatch('dashboardBlog/clearBlog')
    },
    methods: {
      uploadFile(e) {
        let files = e.target.files[0];
        if (!files) return;

        let filesize = (files.size / 1024 / 1024).toFixed(2); // MB
        if (filesize > 200) {
          this.$root.showWarnMsg({
            message: "حجم فایل نباید بیشتر از ۲۰۰ مگابایت باشد... "
          });
          return;
        }
        this.form.pdf = files;
      },
      getTag() {
        // this.$store.commit("dashboardTag/setTagCourse", data.tags);
        this.$store.dispatch("dashboardTag/getTags");
      },
      async saveBlog({draft}) {
        this.isLoading = true
        try {
          if(!this.form.img){
            this.$root.showWarnMsg({
              message: "لطفا عکس حود را ضمیمه کنید."
            });
            return
          }
          let result = await this.$validator.validate()
          if (!result) {
            this.$root.showWarnMsg({
              message: 'لطفا فرم را تکمیل کنید ... '
            })
            return
          }
          this.form.category_id = this.categoryValue.selfId;
          this.form.subcategory_id = this.categoryValue.subcategory_id;
          this.form.as_draft = draft;
          delete this.form.imgSrc;
          let formData = new FormData();
          for (const key in this.form) {
            if (key === "img") {
              formData.append(key, this.form[key], "image.png");
            } else if (key === "pdf") {
              if(this.form[key])
                formData.append("pdf", this.form[key], "file.pdf");
            } else {
              formData.append(key, this.form[key]);
            }
          }
          let tags = this.tags.map(e => e.id);
          if(tags.length)
            formData.append("tags", tags);
          let res = await this.$store.dispatch("dashboardBlog/add", formData);
          if(res){
            this.$router.push("/dashboard/blog/list");
          }else{

          }
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      }
    }
  };
</script>
<style lang="stylus">
  .custom-file-label
    z-index: 0
</style>




// WEBPACK FOOTER //
// src/pages/dashboard/blog/add.vue